/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-05-29 15:04:38
 *
 *******************************************************/
// @flow

export const NUMBER_METAFIELDS = 5;

export const METAFIELD_APP_REVIEWS = [
  { namespace: 'judgeme', key: 'badge' },
  { namespace: 'spr', key: 'reviews' },
  { namespace: 'ssw', key: 'review' }, // reviewsLoyaltyWishlist
  { namespace: 'ryviu', key: 'product_reviews_info' },
  { namespace: 'product_schema', key: 'th_ratingValue' }, // rivyo
  { namespace: 'product_schema', key: 'th_ratingCount' }, // rivyo
  { namespace: 'loox', key: 'avg_rating' },
  { namespace: 'loox', key: 'num_reviews' },
  { namespace: 'okendo', key: 'ProductListingSnippet' },
  { namespace: 'okendo', key: 'summaryData' },
  { namespace: 'scm_review_importer', key: 'reviewsData' }
];
